import { atom } from 'nanostores';
// Atom for tracking whether video is paused
export const $isPausedAtom = atom(false);
